import React, {useState, useEffect} from 'react';
import { Dropdown } from '@fluentui/react';
import RemoveValueFromCommaSeparatedString from "../../../Utils/General/RemoveValueFromCommaSeparatedString";

const ArcDropdown = (props) => {

    const [multiSelectValue, setMultiSelectValue] = useState(null);

    const dropdownStyles = { dropdown: { width: 350 } };

    useEffect(() => {
        if (props.config.MultiSelect) {
            const newValue = props.config.value === null ? "" : props.config.value;
            setMultiSelectValue(newValue);
        }
    }, [props.config]);

    const dropdownChangeHandler = (event, value) => {
        if (event.type !== 'focus') {
            if (value.selected === undefined) {
                props.valueChangeHandler(props.config.Id, value.key, { parentKey: value.ParentKey} );
            } else {
                let newValue= [...props.config.value];
                if (value.selected) {
                    newValue = [...newValue,value.key];
                } else {
                    newValue = [...props.config.value];
                    newValue = newValue.filter(key => key !== value.key);
                }
                props.valueChangeHandler(props.config.Id, newValue, { parentKey: value.ParentKey})
            }            
        }
    }

    const multiSelectChangeHandler = (event, value) => {
        let newValue = multiSelectValue === null || multiSelectValue === undefined ? "" : multiSelectValue;
        if (value.selected) {
            newValue += newValue === "" ? value.key : "," + value.key;
        } else {
            newValue = RemoveValueFromCommaSeparatedString(newValue, value.key, ",");
        }
        setMultiSelectValue(newValue);
        props.valueChangeHandler(props.config.Id, newValue, { parentKey: value.ParentKey} );
    }

    const label = props.config.Label;

    let newValue = null;
    if (props.config.value !== undefined) {
        newValue = props.config.MultiSelect ? props.config.value.split(",") : props.config.value;
    }

    const tabIndex = props.config.noTab === undefined || !props.config.noTab ? 0 : -1;

    let fieldToDisplay = (null);
    if (props.config.Options !== undefined && props.config.Options.length > 0) {

        if (props.config.MultiSelect) {
            fieldToDisplay = <Dropdown
                                onKeyDown={props.onKeyDown}
                                tabIndex={tabIndex}
                                id={props.config.Id}
                                required={props.config.Required}
                                placeholder={props.config.Placeholder}
                                label={label}
                                multiSelect={props.config.MultiSelect}
                                options={props.config.Options}
                                onChange={multiSelectChangeHandler}
                                selectedKeys={newValue}
                                styles={dropdownStyles}
                            />;
        } else if (props.config.Resettable) {
            fieldToDisplay = <Dropdown
                                onKeyDown={props.onKeyDown}
                                tabIndex={tabIndex}  
                                id={props.config.Id}
                                required={props.config.Required}
                                placeholder={props.config.Placeholder} 
                                label={label} 
                                multiSelect={props.config.MultiSelect}
                                options={props.config.Options}
                                onChange={dropdownChangeHandler}
                                selectedKey={newValue}
                            />;
        } else {
            fieldToDisplay = <Dropdown
                                onKeyDown={props.onKeyDown}
                                tabIndex={tabIndex}  
                                id={props.config.Id}
                                required={props.config.Required}
                                placeholder={props.config.Placeholder} 
                                label={label} 
                                multiSelect={props.config.MultiSelect}
                                options={props.config.Options}
                                onChange={dropdownChangeHandler}
                                selectedKey={newValue}
                            />;
        }
    }

    return (
        <React.Fragment>
            {fieldToDisplay}
        </React.Fragment>
    )
}

export default ArcDropdown